import { newToolFilterOAuthMcp } from "../oauth.ts";

export const notionMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.notion.com/front-static/logo-ios.png",
  url: "https://mcp.notion.com/mcp",
  label: "Notion",
});
